import { render } from "./ZirconiaToothInfoForm.vue?vue&type=template&id=8b66a486&scoped=true"
import script from "./ZirconiaToothInfoForm.vue?vue&type=script&lang=js"
export * from "./ZirconiaToothInfoForm.vue?vue&type=script&lang=js"

import "./ZirconiaToothInfoForm.vue?vue&type=style&index=0&id=8b66a486&lang=scss"
import "./ZirconiaToothInfoForm.vue?vue&type=style&index=1&id=8b66a486&scoped=true&lang=scss"
import "./ZirconiaToothInfoForm.vue?vue&type=style&index=2&id=8b66a486&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b66a486"]])

export default __exports__